import {useEffect, useState} from "react";
import {notification} from "antd";
import {HistoryTimeline} from "~/components";
import {contractApi} from "~/api";
import {apiError, handleRequest} from "~/utils";

/**
 * Lịch sử thao tác trên hợp đồng.
 * Hiển thị ai thao tác - thời gian - hành động gì; với cập nhật có bảng so sánh trước/sau.
 */
function ContractHistory({item}) {

	const [histories, setHistories] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const loadData = async () => {
			if (!item?.id) return;
			setLoading(true);
			let [error, response] = await handleRequest(contractApi.history(item.id));
			setLoading(false);
			let message = apiError('Tải lịch sử thao tác thất bại', error, response);
			if (!message) {
				setHistories(response.data || []);
			} else {
				notification.error({message: 'Lỗi', description: message});
			}
		};

		setHistories([]);
		loadData();
	}, [item?.id]);

	return (
		<div className="form">
			<HistoryTimeline
				histories={histories}
				loading={loading}
				emptyText="Chưa có lịch sử thao tác nào cho hợp đồng này"
			/>
		</div>
	);
}

export default ContractHistory;
